import object from '@mailobj-browser/front/js/utils/object.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import { onTapUp } from '../lightboxes/templates/anchor.js'
import { hotkey } from './hotkey.js'

const handler = object(null, {
  task: async (
    element,
    event
  ) => {
    preventDefault(event)
    const anchor = element.closest('a[href="javascript:"]')

    await onTapUp.trigger(anchor)
  }
})

export default (
  element
) => {
  hotkey(element, handler)
}
